module.exports = __webpack_public_path__ + "img/m4_t2_en.50465871.svg";